import React, { useState, useEffect } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Loan_Inquiry_StatusCreate from "./Loan_Inquiry_StatusCreate";
import Loan_Inquiry_Status2Header from "./Loan_Inquiry_Status2Header";
import { useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";

const Loan_Inquiry_Status = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const [permission, setPermission] = useState(null);

  useEffect(() => {
    const getPermission = async () => {
      const roleId = localStorage.getItem("roleId");
      const id = queryParams.get("id");

      const formData = new FormData();
      formData.append("role_id", roleId);
      formData.append("module_id", id);

      try {
        const result = await fetchFormData("get-permission", formData, "POST");
        const perm = result?.data;

        setPermission(perm);
      } catch (error) {
        console.error("Error fetching permission", error);
      }
    };

    getPermission();
  }, [id]);
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Loan_Inquiry_Status2Header permission={permission} />
          </PageHeader>

          <div className="main-content">
            <div className="row">
              <Loan_Inquiry_StatusCreate permission={permission} />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Loan_Inquiry_Status;
